import React, { useEffect, useMemo } from "react";
import * as Sentry from "@sentry/react-native";
import { router } from "expo-router";
import { Alert } from "react-native";

import { useRouterSearchParams } from "@/hooks/router";
import ExploreByCategoryScreen from "@/screens/Explore/ExploreCategory/ExploreByCategoryScreen";
import withSessionHandling, {
  SessionHandlerProps,
} from "@/context/auth/withSessionHandling";
import { RecommendationCategoryFeedSchema } from "@/schemas/user/explore";
import { isMarketingMode } from "@/utils/expo";

function Screen(props: SessionHandlerProps): React.JSX.Element {
  const feedCategoryData = useRouterSearchParams("feedCategoryData");

  const parsedFeedCategoryData = useMemo(() => {
    try {
      const parsed = JSON.parse(feedCategoryData);
      return RecommendationCategoryFeedSchema.parse(parsed);
    } catch (error) {
      Sentry.captureException(error);
      return null;
    }
  }, [feedCategoryData]);

  useEffect(() => {
    if (!parsedFeedCategoryData) {
      Alert.alert("Something went wrong", "Please try again later.", [
        { text: "OK" },
      ]);
      router.back();
    }
  }, [parsedFeedCategoryData]);

  if (!parsedFeedCategoryData) {
    return <></>;
  }

  return (
    <ExploreByCategoryScreen
      {...props}
      key={parsedFeedCategoryData.category + parsedFeedCategoryData.jobId}
      categoryData={parsedFeedCategoryData}
      isMarketingMode={isMarketingMode()}
    />
  );
}

export default withSessionHandling(Screen);
